import React from "react";
import classNames from "classnames";
import { Props } from "./types";
import { ExpenseIcon } from "./expenseIcon";
import styles from "./styles.scss";

function isColorLight(color: string) {
  const hex = color.replace("#", "");
  const c_r = parseInt(hex.substring(0, 2), 16);
  const c_g = parseInt(hex.substring(2, 2 + 2), 16);
  const c_b = parseInt(hex.substring(4, 4 + 2), 16);
  const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;

  return brightness > 155;
}

function ExpenseTypeIcon({ expenseType }: Props) {
  return (
    <div
      className={classNames(styles.tag, {
        [styles.light]: isColorLight(expenseType.color),
      })}
      style={{
        backgroundColor: expenseType.color,
      }}
    >
      <ExpenseIcon className={styles.icon} />
      {expenseType.name}
    </div>
  );
}

export { ExpenseTypeIcon };
